import type { JobOfferV2WithCompanyId } from "../types";

export const isSoloFreelancerJobOffer = (job: JobOfferV2WithCompanyId) =>
  job.company_id?.kind === "solo_freelancer";

export const isWorkspaceUnavailable = (job: JobOfferV2WithCompanyId) =>
  job.company_id?.status === "archived" ||
  (job.company_id?.status != null && job.company_id.status !== "active");

export const getJobOfferPublicBrand = (job: JobOfferV2WithCompanyId) => {
  if (isSoloFreelancerJobOffer(job)) {
    const name = job.posted_by?.full_name ?? job.company_id?.name ?? "";
    return {
      name,
      imageUrl: job.posted_by?.avatar_url ?? job.company_id?.logo_url ?? null,
      fallback: name?.[0]?.toUpperCase() ?? "F",
      label: null,
      isSoloFreelancer: true,
    };
  }

  const name = job.company_id?.name ?? "";
  return {
    name,
    imageUrl: job.company_id?.logo_url ?? null,
    fallback: name?.[0]?.toUpperCase() ?? "A",
    label: null,
    isSoloFreelancer: false,
  };
};
